import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IDebtRolloverHistory } from '../interface/DebitRollover/IDebtRolloverHistory';

enum DebtRolloverHistoryServiceEnum {
  base = "/",
}

export default class DebtRolloverHistoryService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/debt-rollover-history");
  }

  public getAll = async (): Promise<IDebtRolloverHistory[]> => await this.GET(DebtRolloverHistoryServiceEnum.base);
}